import { Eye, Download, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/others/Badges";

export function ChildDocumentCard({ document }: { document: any }) {
  const displayName = document.fileName || document.name || "Untitled";
  const fileType = document.type?.toUpperCase() || "--";

  const handleView = () => {
    if (document.fileUrl) window.open(document.fileUrl, "_blank");
  };

  const handleDownload = () => {
    if (!document.fileUrl) return;
    const a = window.document.createElement("a");
    a.href = document.fileUrl;
    a.download = document.fileName || "download";
    a.click();
  };

  return (
    <div className="flex-1 bg-[rgba(40,12,242,0.02)] border border-[rgba(40,12,242,0.06)] rounded-[12px] px-3 py-1.5 flex gap-2 items-center">
      <div className="relative size-7 shrink-0">
        <FileText className="size-7 text-[#cacfd8]" strokeWidth={1.5} />
        <Badge className="absolute bottom-0.5 left-0 bg-[#fb3748] !rounded-[3px] !px-1 !py-0.5 !text-white !text-[8px] !font-medium uppercase !leading-tight tracking-tight !h-auto border-none">
          {fileType}
        </Badge>
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-[14px] font-medium text-[var(--color-black-10)] tracking-[-0.56px] leading-normal truncate">
          {displayName}
        </p>
      </div>

      <div className="flex items-center gap-0 shrink-0">
        <Button
          variant="ghost"
          size="icon"
          className="size-8 rounded-[12px]"
          style={{
            backgroundImage:
              "linear-gradient(160.304deg, rgba(38, 115, 85, 0.01) 110.38%, rgba(38, 115, 85, 0.12) 110.92%)",
          }}
          onClick={handleView}
        >
          <Eye
            size={22}
            className="text-[var(--color-black-8)]"
            strokeWidth={1.5}
          />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="size-8 rounded-[12px]"
          style={{
            backgroundImage:
              "linear-gradient(160.304deg, rgba(38, 115, 85, 0.01) 110.38%, rgba(38, 115, 85, 0.12) 110.92%)",
          }}
          onClick={handleDownload}
        >
          <Download
            size={14}
            className="text-[var(--color-black-8)]"
            strokeWidth={2}
          />
        </Button>
      </div>
    </div>
  );
}
